export const baseRoutes = {
  userBaseRoutes: "/",
  adminBaseRoutes: "/associate",
  superAdminBasePath: "/superAdmin",
};
